// @flow

import styled, { css } from 'styled-components';

export const Button = styled.button`
  background: none;
  background-color: black;

  border: none;
  border-radius: 6px;
  outline: none;

  color: white;
  font-size: 1.2em;
  font-weight: 600;
  font-family: "Open Sans","OpenSans",Arial,"Helvetica Neue",Helvetica,sans-serif;
  letter-spacing: 0.08em;
  overflow: hidden;
  text-align: center;
  text-decoration: none;
  text-overflow: ellipsis;
  text-transform: uppercase;

  padding: 1em 0.5em;

  transition: filter 200ms cubic-bezier(0, 0, 0.2, 1);

  ${({ disabled }) => !disabled && css`
    filter: brightness(115%);
  `}

  ${({ height }) => height && css`
    height: ${height};
  `}

  ${({ block }) => block && css`
    display: block;
    width: 100%;
  `}

  ${({ background }) => background && css`
    background: ${background};
  `}


  ${({ outline }) => outline && css`
    background-color: transparent;
    border: 2px solid;
    border-color: ${outline === true ? 'black' : outline};
    color: black;
    font-weight: 600;
  `}
`;
